import actions from '@/core/store/pedido/dotacao-orcamentaria/actions'

export default { actions }
